import { injectIntl } from 'react-intl';

import { AbbreviatedNumberComponent } from '../components/abbreviated-number-component';

export const AbbreviatedNumber = injectIntl(AbbreviatedNumberComponent);
